import './spinner.scss';

const Spinner = () => (
  <div className="loader-wrapper">
    <div className="loader" />
  </div>
);

export default Spinner;
